import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('FIXED ASSET SERVICE CONFIGURATIONS SERVICE');

@Injectable({
  providedIn: 'root'
})
export class FixedAssetServiceConfigurationsService extends ApiBaseService<any>{

  constructor() {
    // Recurso del catálogo de Configuración de Servicio de Activo Fijo
    super('fixedAssetServiceConfigurations');
    log.debug('Servicio de Configuración de Servicio de Activo Fijo inicializado');
  }

}
